import React from "react";
import { Box, Table, TableBody } from "@mui/material";
import { HeaderInfo } from "../../types";
import SearchResultTableHeader from "./table_header";
import { tableResponse, tablesObjects } from "../../constants";
import TableRowContent from "./table_row_content";
import { useNavigate } from "react-router-dom";

interface DataTableProps {
  data: HeaderInfo;
  hasRows: boolean;
  onViewAllHandler: (header: HeaderInfo) => void;
  handleClose?: () => void;
}

const DataTable: React.FC<DataTableProps> = ({
  data,
  hasRows,
  onViewAllHandler,
  handleClose,
}) => {
  const navigate = useNavigate();
  const isRowDisabled = (row: { column_five: string }) => {
    return row.column_five === "Cancelled" || row.column_five === "Failed";
  };

  const handleRowClick = (item: {
    type: string;
    id: string;
    data: { status: string };
  }) => {
    console.log("Row clicked:", item);
    if (handleClose) {
      handleClose();
    }

    if (item.type === tableResponse.Assets) {
      const assetId = item.id || (item as any).data?.id_device || (item as any).data?.id || (item as any).data?.device_id || "";
      console.log("Navigating to assets with state ID:", assetId);
      const targetUrl = tablesObjects[item.type].url.startsWith("/")
        ? tablesObjects[item.type].url
        : `/${tablesObjects[item.type].url}`;
      navigate(targetUrl, { state: { id: assetId } });
    } else if (item.type === tableResponse.Scans) {
      const scanName = String((item as any).column_one || "").toLowerCase();
      if (scanName.includes("cloud")) {
        navigate("/on-premises/scans", { state: { scan_id: item.id } });
      } else {
        navigate(
          `${tablesObjects[item.type].url}/${item.id}`
        );
      }
    } else if (
      item.type === tableResponse.Parameters ||
      item.type === tableResponse.Benchmarks ||
      item.type === tableResponse.CloudControls
    ) {
      const stateId = item.id || (item as any).data?.id || "";
      console.log(`Navigating to ${item.type} with state ID:`, stateId);
      const targetUrl = tablesObjects[item.type].url.startsWith("/")
        ? tablesObjects[item.type].url
        : `/${tablesObjects[item.type].url}`;
      
      const navigationState: any = { id: stateId, type: item.type };
      if (item.type === tableResponse.Benchmarks) {
        navigationState.control_type = (item as any).column_one || (item as any).data?.name || "";
      }
      
      navigate(targetUrl, { state: navigationState });
    } else if (item.type === tableResponse.Resources) {
      const resourceId = item.id || (item as any).data?.id_device || (item as any).data?.id || (item as any).data?.device_id || "";
      console.log("GLOBAL SEARCH - Clicking individual Cloud Resource row");
      console.log("GLOBAL SEARCH - Navigating to URL:", tablesObjects[item.type].url);
      console.log("GLOBAL SEARCH - Sending state payload:", { id: resourceId, module: "cloud" });
      const targetUrl = tablesObjects[item.type].url.startsWith("/")
        ? tablesObjects[item.type].url
        : `/${tablesObjects[item.type].url}`;
      navigate(targetUrl, { state: { id: resourceId, module: "cloud" } });
    } else if (item.type === tableResponse.Roles) {
      const roleId = item.id || (item as any).data?.id || "";
      console.log("Navigating to Roles with state ID:", roleId);
      const targetUrl = tablesObjects[item.type].url.startsWith("/")
        ? tablesObjects[item.type].url
        : `/${tablesObjects[item.type].url}`;
      navigate(targetUrl, { state: { id: roleId } });
    } else if (item.type === tableResponse.Users) {
      const userId = item.id || (item as any).data?.id || "";
      console.log("Navigating to Users with state ID:", userId);
      const targetUrl = tablesObjects[item.type].url.startsWith("/")
        ? tablesObjects[item.type].url
        : `/${tablesObjects[item.type].url}`;
      navigate(targetUrl, { state: { id: userId } });
    } else if (item.type === tableResponse.CVE) {
      const cveId = item.id || (item as any).data?.id || "";
      console.log("Navigating to CVE with state ID:", cveId);
      const targetUrl = tablesObjects[item.type].url.startsWith("/")
        ? tablesObjects[item.type].url
        : `/${tablesObjects[item.type].url}`;
      navigate(targetUrl, { state: { id: cveId } });
    }
  };

  return (
    <Box
      className={`search-table${!hasRows ? " remove-space" : ""}${
        data?.key === "Cve" ? " cve-table" : ""
      }`}
    >
      {/* Header with icons */}
      {hasRows && data.isApiCall && (
        <Box className="table-header" mb={2}>
          <SearchResultTableHeader
            header={data}
            onViewAllHandler={onViewAllHandler}
            handleClose={handleClose}
          />
        </Box>
      )}

      {/* Table Data */}
      {hasRows && (
        <Table>
          <TableBody>
            {data.data.map((row, rowIndex) => (
              <TableRowContent
                key={rowIndex}
                row={row}
                isDisabled={isRowDisabled(row)}
                onClick={() => !isRowDisabled(row) && handleRowClick(row)}
              />
            ))}
          </TableBody>
        </Table>
      )}
    </Box>
  );
};

export default DataTable;
